module.exports = __webpack_public_path__ + "img/293.7177681b.jpg";